import * as types from '../types';

const defaultState = {
  date: null,
  ip: null,
  name: null,
  geo: {
    country: null,
    region: null,
    city: null
  }
};

export default function serverInfoReducer(state = defaultState, action) {
  switch (action.type) {
    case types.SET_SERVER_DATE:
      return {
        ...state,
        date: action.value
      };

    case types.SET_SERVER_IP:
      return {
        ...state,
        ip: action.value
      };

    case types.SET_SERVER_NAME:
      return {
        ...state,
        name: action.value
      };

    case types.SET_SERVER_GEO:
      return {
        ...state,
        geo: {
          country: action.value ? action.value.country : null,
          region: action.value ? action.value.region : null,
          city: action.value ? action.value.city : null
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/serverInfo.js